import SearchFilterAgenda from "./modules/searchFilterAgenda";

document.addEventListener("DOMContentLoaded", function () {
    new SearchFilterAgenda();
});
